import { apiRequest } from './client'
import { demoProductTypesL0Options } from '../dev/buyerDemoData'
import { withDemoUi } from '../dev/demoMode'

export type EnumOptionDto = {
  code: string
  label: string
}

export type CityOptionDto = {
  code: string
  label: string
}

export const listCities = () => apiRequest<CityOptionDto[]>('/reference/cities', { auth: false })

export const listHorecaTypes = () =>
  apiRequest<EnumOptionDto[]>('/reference/buyer-subtypes', { auth: false })

export type ProductTypeL0Option = {
  id: number
  name: string
}

export const listProductTypesL0 = (): Promise<ProductTypeL0Option[]> =>
  withDemoUi(demoProductTypesL0Options(), async () => {
    const items = await apiRequest<Array<{ id: number; name: string }>>('/reference/product-types/l0', {
      auth: false,
    })
    return items.map((item) => ({ id: item.id, name: item.name }))
  })
